import { observer } from 'mobx-react-lite'
import React, { Fragment } from 'react'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import CampaignProvider from '../../../contexts/CampaignContext'
import Analytics from './CampaignPageParts/Analytics'
import BudgetTable from './CampaignPageParts/BudgetTable'
import BudgetTableNew from './CampaignPageParts/BudgetTableNew'
import CampaignSideBar from './CampaignPageParts/CampaignSidebar'
import DraftProcess from './CampaignPageParts/DraftProcess'
import ContentDrafts from './CampaignPageParts/ContentDrafts'
import Files from './CampaignPageParts/Files'
import Overview from './CampaignPageParts/Overview'
import Influencers from './CampaignPageParts/Influencers'
import ProjectTimeline from './CampaignPageParts/ProjectTimeline'
import Report from './CampaignPageParts/Report'
import ArchivedReadOnlyProvider from './CampaignPageParts/ArchivedReadOnlyProvider'
import { useSidebarCollapse } from '../../../contexts/SidebarCollapseContext'

function NavigateToPmCampaignChild({ suffix }) {
  const { id } = useParams()
  return <Navigate to={`/project_manager/campaigns/${id}/${suffix}`} replace />
}

export default observer(function ProjectManagerCampaign() {
  const { isCollapsed } = useSidebarCollapse()

  return (
    <Fragment>
      <CampaignProvider>
        <ArchivedReadOnlyProvider>
          <CampaignSideBar />
          <div className={`pt-12 ${isCollapsed ? 'pl-14' : 'pl-56'} bg-rb-grey dark:bg-rb-dark-mode-background transition-all duration-300`}>
            <Routes>
              <Route path="overview" element={<Overview />} />
              <Route path="files" element={<Files />} />
              <Route path="campaign_folders/:campaign_folder_id/files" element={<Files />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="influencers" element={<Influencers />} />
              <Route path="influencers/*" element={<Influencers />} />
              <Route path="project_timeline" element={<ProjectTimeline />} />
              <Route path="project_timeline/:campaign_scenario_id" element={<NavigateToPmCampaignChild suffix="project_timeline" />} />
              <Route path="draft_process" element={<DraftProcess />} />
              <Route path="draft_process/participants/:influencer_id" element={<DraftProcess />} />
              <Route path="draft_process/participants/:influencer_id/actions/:action_id" element={<DraftProcess />} />
              <Route path="content_drafts" element={<ContentDrafts />} />
              <Route path="content_drafts/participants/:influencer_id" element={<ContentDrafts />} />
              <Route path="content_drafts/participants/:influencer_id/actions/:action_id" element={<ContentDrafts />} />
              <Route path="budget_table" element={<BudgetTable />} />
              <Route path="budget_table/:campaign_scenario_id" element={<NavigateToPmCampaignChild suffix="budget_table" />} />
              <Route path="budget_table_new" element={<BudgetTableNew />} />
              <Route path="budget_table_new/:campaign_scenario_id" element={<NavigateToPmCampaignChild suffix="budget_table_new" />} />
              <Route path="report" element={<Report />} />
            </Routes>
          </div>
        </ArchivedReadOnlyProvider>
      </CampaignProvider>
    </Fragment>
    )
})
